import React from 'react';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AnnouncementRecipients } from '../Announcement.types';
import { Strong } from '../../../components/atoms/Strong/Strong';

export type AnnouncementSenderRecipientProps = {
  renderRecipients: any;
  renderSender: any;
} & AnnouncementRecipients;

export function AnnouncementSenderRecipient({
  renderRecipients,
  renderSender,
  recipients,
}: AnnouncementSenderRecipientProps) {
  const { t } = useSonTranslation('Announcement');

  return (
    <ContentParagraph>
      <span className="announcement__sender-recipient">
        {recipients && !recipients.sendToAll && recipients.recipientList.length === 0
          ? (
              <Strong>{t('noRecipients')}</Strong>
            )
          : (
              <>
                <dfn className="announcement__definition-text">{recipients ? t('to') : t('from')}:</dfn>
                <span className="announcement__definition-description">
                  {recipients ? renderRecipients() : renderSender()}
                </span>
              </>
            )}
      </span>
    </ContentParagraph>
  );
}
